<div (click)="onClick()"
  class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-5 group cursor-pointer hover:shadow-md transition-all duration-200 relative overflow-hidden">

  <!-- Accent bar on top -->
  <div class="absolute top-0 left-0 right-0 h-0.5 transition-opacity duration-200"
    [ngStyle]="{'background': accentColor}"></div>

  <!-- Icon + Title row -->
  <div class="flex items-center justify-between mb-4">
    <div class="w-10 h-10 rounded-lg flex items-center justify-center border transition-colors"
      [ngStyle]="{'backgroundColor': accentColor + '18', 'borderColor': accentColor + '30'}">
      <img [src]="icon()" alt="Icon" class="w-5 h-5 transition-opacity" [style.filter]="'none'" />
    </div>
    <span class="text-[9px] font-bold uppercase tracking-widest px-2 py-1 rounded border opacity-0 group-hover:opacity-100 transition-opacity"
      [ngStyle]="{'color': accentColor, 'backgroundColor': accentColor + '12', 'borderColor': accentColor + '30'}">
      {{ text }}
    </span>
  </div>

  <!-- Metric -->
  <div>
    <p class="text-xs font-semibold text-slate-400 mb-1">{{ title() }}</p>
    <h2 class="text-3xl font-bold text-slate-900 dark:text-white tracking-tight transition-colors leading-none group-hover:opacity-80">
      {{ total() ?? '—' }}
    </h2>
  </div>

</div>
